import { css } from "styled-components";

export const createScrollbarStyle = () => css`
  /* Firefox */
  @-moz-document url-prefix() {
    scrollbar-color: ${({ theme }) => theme.colors.textFade} #00000000;
    scrollbar-width: thin;
  }

  /* Chrome and Safari */
  &::-webkit-scrollbar {
    appearance: none;
    height: 3px;
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    opacity: 0;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0.25rem;
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.textFade};
    }
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.textBright};
  }
`;
